import React from "react";
import { ContractProjectLayout } from "../../layouts/ContractProjectHeaderLayout/ContractProjectHeaderLayout";
import { DataLensContainer } from "../../containers/DataLensContainer/DataLensContainer";
import { CommonLayout } from "../../layouts/CommonLayout/CommonLayout";
import { DataLensLayout } from "../../layouts/DataLensLayout/DataLensLayout";

export const DataLensPage = () => {

    return(
        <DataLensLayout>
            <DataLensContainer />
        </DataLensLayout>
    )
}